import React from 'react'
import ReactDOM from 'react-dom'

export default function ModalManager({ isOpen, children }) {
    if (!isOpen) return null

    const modalRootEl = document.getElementById('modal-root')

    return ReactDOM.createPortal(
        <React.Fragment>{children}</React.Fragment>,
        modalRootEl,
    )
}
